/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { css } from '@emotion/react'
import { get } from 'lodash'

import Card from '../card'
import Paragraph from '../paragraph'

import { resolveButtons } from '../../lib/helpers'

const CTA = (props) => {
  const { title, acfCTA, ...otherProps } = props

  const sectionColor = get(acfCTA, 'sectionColor')
  const text = get(acfCTA, 'textContent')
  const buttons = get(acfCTA, 'buttons')

  return (
    <Card color={sectionColor}>
      <Paragraph
        heading={title}
        hTier={3}
        htmlText={text}
        buttons={resolveButtons(buttons)}
        align="center"
      />
    </Card>
  )
}

export default CTA
